import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
// import Drawer from '@material-ui/core/Drawer';
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
// import List from '@material-ui/core/List';

// import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import Divider from '@material-ui/core/Divider';
// import IconButton from '@material-ui/core/IconButton';
// import Badge from '@material-ui/core/Badge';
// import MenuIcon from '@material-ui/icons/Menu';
// import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
// import NotificationsIcon from '@material-ui/icons/Notifications';
// import { mainListItems, secondaryListItems } from './listItems';
import StrengthChart from './strengthchart';
import SpeedChart from './speedchart';
import MapCard from './map';
import MediaControlCard from './mediaControl';
import DatePickers from './datepickers';
import VehicleSocket from './containers/VehicleSocket';
import TopBar from './appBar';
import { connect } from 'react-redux'
import * as vehicleActions from "./actions/vehicles";
import { bindActionCreators } from "redux";
import TextField from '@material-ui/core/TextField';




const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    // padding: theme.spacing.unit * 1,
    // padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
    width: '100%',
  },
  demo: {
    // height: '100%',
    padding: theme.spacing.unit,
  },
  center: {
    textAlign: 'center',
  },
  left: { textAlign: 'center', },
  paper: {
    padding: theme.spacing.unit * 2,
    height: '27%',
    textAlign: 'left',
    color: theme.palette.text.secondary,
    margin: '0 2px 2px ',
  },
  control: {
    padding: theme.spacing.unit * 2,
  },
  card: {
    minWidth: 2,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 12,
  },
  pos: {
    marginBottom: 12,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },

  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    width: '100%',
    height: '70%',
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
    margin: '0 0 0 12px',
  },
});


class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      realtime: false,
      dtFrom: new Date().toISOString(),
      dtTo: new Date().toISOString(),
      marker: 0,
      vLength: 0,
      didMount: false,
    };

  }

  componentDidMount() {
    this.setState({ didMount: true });
  }

  componentWillReceiveProps(nextProps) {
    // if(nextProps.value !== this.props.value) {
    //   this.setState({value: nextProps.value});
    // }
    console.log('compwill-receive props');
    this.setState({ marker: 0 });
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = (dtFrom, dtTo) => {
    // this.setState({ realtime: false });
    // var oneWeekAgo = new Date();
    // oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    // dtFrom=new Date().getTime().toString();
    // dtTo = "1543788771484";
    if (dtFrom.trim() && dtTo.trim()) {
      this.props.actions.fetchVehicles(dtFrom.trim(), dtTo.trim());
      this.handleReset();
      this.stopPlayMap();
    }
  }

  handleReset = () => {
    this.setState({
      dtFrom: '',
      dtTo: ''
    });
  };
  handleRealTimeClick = () => {
    console.log('RT', this.state.realtime)
    this.setState({ realtime: true });
  };

  handleSlideClick = (pos) => {
    console.log(`pos ${pos}`);
    this.stopPlayMap();
    this.setMarker(pos);
  }

  handleMediaControlChange = (step) => {
    console.log('media', step);
    this.stopPlayMap();
    let num = this.state.marker;
    let len = this.props.vehicles.length;
    console.log(`mediamarker ${num} , len= ${len - 1}`);
    switch (step) {
      case 0:
        num = 0;
        break;
      case -1:
        num = ((num - 1) > 0) ? num - 1 : 0;
        break;
      case -5:
        this.stopPlayMap();
        break;
      case 5:
        this.playMap(num);
        break;
      case 1:
        num = ((num + 1) < len) ? num + 1 : len - 1;
        break;
      case 9:
        num = len - 1;
        break;
    }
    console.log(`num  ${num}`);
    this.setMarker(num);
    // this.setState({ value: num });
    // this.props.click(this.state.value);
  };

  //  setLoop = setInterval(playMap, 1000);

  playMap(value) {
    if (this.state.didMount && (value >= 0)) {
      let len = this.props.vehicles.length;
      this.setLoop = setInterval(() => {
        let step = (value > len - 1) ? value = value - len : value++;
        this.setMarker(step);
      }, 1000);

    }
  }

  stopPlayMap() {
    if (this.setLoop)
      clearInterval(this.setLoop);
  }

  setMarker(value) {
    console.log('setMarker', value);
    this.setState(()=>({
      marker: value
    }));
  }


  render() {
    const { classes } = this.props;
    const { vehicles } = this.props;
    const { realtime, marker } = this.state;
    let ts;
    console.log('marker....', marker);
    if (marker) {
      if (typeof vehicles !== 'undefined' && vehicles.length > 0) {
        ts = vehicles[marker]["timestamp"];
      } else { ts = marker; }
    } else {
      // alert ('marker null');
    }
    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container className={classes.root}
          direction="row" justify="center" alignments="stretch">
          <VehicleSocket realtime={realtime}>
            <TopBar />
            <Grid item xs={8} className={classes.demo}   >
              <Typography variant="h4" gutterBottom   >
                Vehicle Statestics
          </Typography>
              <MapCard className={classes.demo} pos={marker} />
              {/* <Paper  > */}
              <Grid container justify="center"     >
                <MediaControlCard max={vehicles.length - 1} value={marker} click={this.handleSlideClick} MediaControlChange={this.handleMediaControlChange} />
              </Grid>
              {/* </Paper> */}
            </Grid>
            <Grid container alignments="stretch" className={classes.demo} direction="column" item xs={4}  >
              <Paper  >
                <Paper  >
                  <DatePickers submit={this.handleSubmit} realtimeclick={this.handleRealTimeClick} />
                </Paper>
                <Paper className={classes.paper}>
                  <Typography variant="subtitle2" gutterBottom   >
                    Signal Strength
          </Typography>
                  <StrengthChart pos={ts} />
                </Paper>
                <Paper className={classes.paper}>
                  <Typography variant="subtitle2" gutterBottom  >
                    Speed
          </Typography>
                  <SpeedChart pos={ts} />
                </Paper>
                <Paper className={classes.paper}>
                  <Typography variant="subtitle2" gutterBottom  >
                    Acceleration
                </Typography>
                  <SpeedChart pos={ts} />
                </Paper>
              </Paper>
            </Grid>
          </VehicleSocket>
        </Grid>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

// const mapStateToProps = (state) => {
//   return {
//     vehicles: state.vehicles
//   }
// };

const mapStateToProps = (state) => state;
const mapDispatchToProps = (dispatch, props) => {
  return {
    actions: bindActionCreators(vehicleActions, dispatch)
  }
}
// const connectDash = connect(mapStateToProps)(Dashboard);
// const withStyleDash = withStyles(styles)(connectDash);

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
